module.exports = __webpack_public_path__ + "static/media/BW201910_02.fa807ad3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/BW201910_02.jpg
// module id = 369
// module chunks = 0